__webpack_require__.p = "/wp-content/plugins/tirechvue/cadastro/cad_campanhas/appjs/dist/";